import { TableCellAction } from '@components/Table/TableCellAction';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { IMenu } from '@hooks/useMenu';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { IClienteEvento } from '@model/ClienteEvento';
import { EnumClienteEventoStatus, useClienteEventoStatusColor } from '@model/ClienteEventoStatus';
import { IClienteEventoFilter } from '@services/ClienteService';
import React from 'react';

export type EventoTableProps = {
    data: IData<IClienteEvento, IClienteEventoFilter>
    isLoading: boolean
    menu: IMenu
}

export function EventoTable ({ data, isLoading, menu }: EventoTableProps) {
    const formatter = useFormatter();
    const clienteEventoStatusColor = useClienteEventoStatusColor();

    const hasOptions = React.useCallback((clienteEvento: IClienteEvento) => {
        return clienteEvento.clienteEventoStatusId !== EnumClienteEventoStatus.Cancelado;
    }, []);

    return (
        <React.Fragment>
            <TableLinearLoading isLoading={isLoading} />

            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Tipo</TableHeaderCell>
                        <TableHeaderCell>Data/Hora</TableHeaderCell>
                        <TableHeaderCell>Nota</TableHeaderCell>
                        <TableHeaderCell>Usuário</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCellAction />
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((clienteEvento, index) => {
                        return (
                            <TableRow key={index}>
                                <TableKeyCell>{clienteEvento.clienteEventoId}</TableKeyCell>
                                <TableCell>{clienteEvento.clienteEventoTipoNome}</TableCell>
                                <TableCell>{formatter.toDate(clienteEvento.dataHora)}</TableCell>
                                <TableCell>{clienteEvento.nota}</TableCell>
                                <TableCell>{clienteEvento.usuarioNome}</TableCell>
                                <TableCell className={clienteEventoStatusColor[clienteEvento.clienteEventoStatusId]}>{clienteEvento.clienteEventoStatusNome}</TableCell>
                                <TableCellAction 
                                    disabled={!hasOptions(clienteEvento)}
                                    onButtonClick={data.handleRowFocused(clienteEvento, menu.open)}
                                />
                            </TableRow>
                        )
                    })
                }
                </TableBody>
            </TableNoResult>
        </React.Fragment>
    )
}